import { Box, styled } from "@mui/material";
import { FC, PropsWithChildren } from "react";

const ContentStyles = styled('div')(`
/*
 * fsc = Feral Scan Content
 */

/*
 * Image Row
 */

.fsc-image-row {
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    box-sizing: unset;
}

.fsc-image-row > div {
    padding: 12px;
}

.fsc-image-row > div:first-of-type {
    max-width: 75%;
}

.fsc-image-row > div:first-of-type img {
    width: 100%;
}

.fsc-image-row > div:nth-of-type(2) {
    flex: 1;
}

.fsc-image-circle > img {
    border-radius: 50%;
}

@media only screen and (min-width: 700px) {

    .fsc-image-row {
        flex-direction: row;
        flex-wrap: wrap;
    }

    .fsc-image-row.fsc-image-row-reverse {
        flex-direction: row-reverse;
    }

    .fsc-image-row > div:first-of-type {
        max-width: 50%;
    }

    .fsc-image-small {
        width: 30%;
    }
    .fsc-image-medium {
        width: 40%;
    }
    .fsc-image-large {
        width: 50%;
    }
}

/*
 * Utilities
 */

.smallScreen-hide {
    display: none;
}

@media only screen and (min-width: 1300px) {
    .smallScreen-hide {
        display: block;
    }

    .bigScreen-hide {
        display: none;
    }
}

.link-arrow:after {
    /*margin: 0px 0px 0px 10px;
    text-decoration: none;
    content: '\\1F517';*/
}

/*
 * Colours
 */

.primary {
    color: #ff6600;
    color: var(--speciesPrimaryColor);
}

.secondary {
    color: #AC3F30;
    color: var(--speciesSecondaryColor);
}

.tertiary {
    color: #673628;
    color: var(--speciesContrastColor);
}

/*
 * Card
 */

.card {
    border-radius: 2px;
    background-color: #fff;
    padding: 8px 16px;
    box-shadow: 0px 0px 2px 0px rgba(0,0,0,0.24);
    margin: 12px 0;
}

.card-title {
    font-size: 1rem;
    margin: 8px 0;
}

.card-title.icon-link > .icon-typography-icon {
    height: 1rem;
}

/*
 * Icon Link
 */

.icon-typography {
    font-size: 1rem;
}

.icon-typography > a {
    display: inline-flex;
}

.icon-typography-icon {
    height: 24px;
    width: 24px;
}

.icon-typography-text, .icon-typography-icon {
    vertical-align: middle;
    display: inline-block;
}


/*
 * Modal
 */
.fs-modal {
    z-index: 5;
    background-color: #FFFFFF;
    border: 0;
    display: none;
    position: absolute;
    height: 100%;
    width: 100%;
    /* Fall back scroll off page */
    max-width: 100%;
    max-height: 100%;
    overflow: auto;
}

@media only screen and (min-width: 600px) {
    .page_screen {
        display: block;
    }

    .fs-modal {
        border-radius: 2px;
        box-shadow: 0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24);
        height: auto;
        width: 75%;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        position: absolute;
    }

    .fs-modal-body {
        padding: 10px 20px;
    }
}

@media only screen and (min-width: 992px) {
    .fs-modal {
        width: auto;
    }
}

.fs-modal-header {
    display: flex;
    justify-content: space-between;
    padding: 16px 24px;
    color: rgba(0,0,0,.65);
    background: #fff;
    border-bottom: 1px solid #f0f0f0;
    border-radius: 2px 2px 0 0;
}

.fs-modal-title {
    font-size: 1.25rem;
    line-height: 24px;
}

.fs-modal-body {
    padding: 10px 15px;
}

.fs-modal-footer {
    display: flex;
    /* Reverse direction so by default button is right justified */
    flex-direction: row-reverse;
    justify-content: space-between;
    border-top: 1px solid #f0f0f0;
    text-align: right;
    padding: 10px;
}

/*
 * Buttons
 */

.btnBase {
    -webkit-appearance: none;
    border-radius: 3px;
    background-color: #fff;
    border: 1px solid;
    border-color: #d9d9d9;
    cursor: pointer;
    display: inline-block;
    padding: 12px 40px;
    font-weight: bold;
    text-decoration: none;
    white-space: nowrap;
    text-align: center;
    color: black;
}

.btnBase:hover {
    border-color: #ff6600;
    border-color: var(--speciesPrimaryColor);
}

.btnClear {
    width: 24px;
    height: 24px;
    line-height: 24px;
    cursor: pointer;
    position: relative;
}

.btnClear:hover:before {
    content: "";
    display: block;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 32px;
    height: 32px;
    border-radius: 50%;
    background: rgba(150, 150, 150, 0.2);
}

.btnCircle {
    border-radius: 100%;
    width: 24px;
    height: 24px;
    padding: 0.5rem;
}

.btnCircle:hover {
    border-color: #d9d9d9;
    box-shadow: 0 0px 3px 2px rgba(0,0,0,0.12), 0 0px 2px rgba(0,0,0,0.24);
    color: #1890ff;
}

.btnRounded {
    border-radius: 25%;
    width: 24px;
    height: 24px;
    padding: 0.5rem;
}

.btnEllipse {
    border-radius: 30px;
}

.btnIcon-inner {
    display: flex;
    align-items: center;
    justify-content: center;
    line-height: 1rem;
    font-size: 1rem;
}

.btnPrimary {
    -webkit-appearance: none;
    border-radius: 3px;
    background-color: var(--speciesPrimaryColor);
    border: 1px solid;
    border-color: #d9d9d9;
    cursor: pointer;
    display: inline-block;
    padding: 9px 30px;
    text-decoration: none;
    white-space: nowrap;
    text-align: center;
    color: white;
    font-family: ‘Montserrat', 'sans-serif’;
    font-size: 1.2rem;
}

    .btnPrimary:hover {
        -webkit-box-shadow: 0px 0px 6px 1px rgba(75,90,35,0.5);
        -moz-box-shadow: 0px 0px 6px 1px rgba(75,90,35,0.5);
        box-shadow: 0px 0px 6px 1px rgba(75,90,35,0.5);
    }

/*
 * Backgrounds
 */

.bg-white {
    background-color: #fff;
}


/*
 * Tables
 */

.data-table-container {
}

.fs-table {
    border: 1px solid #f0f0f0;
    border-spacing: 0;
    width: 100%;
}

.fs-table th {
    background: rgba(0,0,0,.02);
    border-bottom: 1px solid #f0f0f0;
    padding: 1rem .75rem;
}

.fs-table td {
    border-bottom: 1px solid #f0f0f0;
}

.fs-table-small {
    width: 130px;
}

.fs-table-action {
    width: 60px;
    text-align: center;
}

.fs-table > tbody > tr > td {
    padding: 0.5rem .75rem;
}

.fs-table > tbody > tr:hover {
    background: rgba(0,0,0,.02);
}

.fs-table-no-results {
    padding: 0.5rem 0.5rem;
}

.fs-pagination {
    cursor: default;
    display: block;
    margin-top: 12px;
    margin-bottom: 12px;
    line-height: 30px;
    font-size: 0; /* Fix UL spacing issue */
}

.fs-pagination-right {
    float: right;
}

.fs-pagination-item {
    user-select: none;
    font-size: 14px;
    cursor: pointer;
    display: inline-block;
    height: 30px;
    width: 30px;
    list-style: none;
    text-align: center;
    vertical-align: middle;
}

.fs-pagination-item-link {
    border: 1px solid;
    border-color: transparent;
    display: inline-block;
    height: 100%;
    width: 100%;
}

.fs-pagination-item-active > .fs-pagination-item-link {
    border-color: #1890ff;
    color: #1890ff;
}

.fs-pagination-item-link:hover {
    border-color: #1890ff;
    color: #1890ff;
}

.fs-table-controls-select {
    display: inline-block;
    height: 30px;
    vertical-align: middle;
    list-style: none;

    background-color: #fff;
    border: 1px solid #d9d9d9;
    border-radius: 2px;
    margin-top: 12px;
    margin-bottom: 12px;
    margin-right: 8px;
}

.fs-table-controls-select:hover {
    border-color: #1890ff;
}

/*
 * Select
 */
.data-select-container {
    width: 100%;
}

.data-select-container > .fs-select {
    width: 100%;
}

.fs-select {
    background-color: #fff;
    border: 1px solid #d8d8d8;
    border-radius: 2px;
    padding: 5px 10px;
}

select.fs-select {
    font-size: 1rem;
}

/*
 * Text
 */

h1.page-title {
    font-size: 2rem;
    color: white;
}

h2.page-subtitle {
    font-size: 1.75rem;
    color: white;
}

h2.page-subtitle {
    font-size: 1.5rem;
    color: white;
    margin-top: 4px;
}


/*
 * Popup
 */

.fs-popup {
    background: #ff6600;
    background: var(--speciesPrimaryColor);
    border-radius: 4px;
    box-shadow: rgba(0, 0, 0, 0.3) 0px 1px 4px -1px;
    padding: 20px;
    color: white;
    margin: 0 12px;
    position: relative;
    max-width: 200px;
}

.fs-popup-up:before {
    content: "";
    position: absolute;
    border-left: 12px solid transparent;
    border-right: 12px solid transparent;
    border-bottom: #ff6600;
    border-bottom: 12px solid var(--speciesPrimaryColor);
    left: 12px;
    top: -10px;
}

.fs-popup-title {
    font-size: 1.3rem;
    font-weight: 500;
}

.fs-popup-body {
    padding: 16px 0;
    font-size: 1rem;
    line-height: 1.75rem;
}

.fs-popup-footer {
    margin: 0;
    padding: 0;
    text-align: right;
}

.fs-popup-close {
    font-size: 1rem;
    font-weight: 900;
    text-transform: uppercase;
    cursor: pointer;
    display: inline;
    padding: 4px 8px;
    border: 1px solid white;
    border-radius: 4px;
}

.fs-popup-close:hover {
    background: rgba(255,255,255,0.2);
}

@media only screen and (min-width: 375px) {
    .fs-popup {
        max-width: 250px;
    }
}
/*
 * What follows is the result of much research on cross-browser styling.
 * Credit left inline and big thanks to Nicolas Gallagher, Jonathan Neal,
 * Kroc Camen, and the H5BP dev community and team.
 */

/* ==========================================================================
   Base styles: opinionated defaults
   ========================================================================== */

/*
 * Remove text-shadow in selection highlight:
 * https://twitter.com/miketaylr/status/12228805301
 *
 * These selection rule sets have to be separate.
 * Customize the background color to match your design.
 */

::selection {
    background: #b3d4fc;
    text-shadow: none;
}

/*
 * A better looking default horizontal rule
 */

hr {
    display: block;
    height: 1px;
    border: 0;
    border-top: 1px solid #ccc;
    margin: 1em 0;
    padding: 0;
}

/*
 * Remove the gap between audio, canvas, iframes,
 * images, videos and the bottom of their containers:
 * https://github.com/h5bp/html5-boilerplate/issues/440
 */

audio,
canvas,
iframe,
img,
svg,
video {
    vertical-align: middle;
}

/*
 * Remove default fieldset styles.
 */

fieldset {
    border: 0;
    margin: 0;
    padding: 0;
}

/*
 * Allow only vertical resizing of textareas.
 */

textarea {
    resize: vertical;
}

/* ==========================================================================
   Browser Upgrade Prompt
   ========================================================================== */

.browserupgrade {
    margin: 0.2em 0;
    background: #ccc;
    color: #000;
    padding: 0.2em 0;
}

/* ==========================================================================
   Helper classes
   ========================================================================== */

/*
 * Hide visually and from screen readers
 */

.hidden {
    display: none !important;
}

/*
 * Hide only visually, but have it available for screen readers:
 * http://snook.ca/archives/html_and_css/hiding-content-for-accessibility
 */

.visuallyhidden {
    border: 0;
    clip: rect(0 0 0 0);
    height: 1px;
    margin: -1px;
    overflow: hidden;
    padding: 0;
    position: absolute;
    width: 1px;
}

/*
 * Extends the .visuallyhidden class to allow the element
 * to be focusable when navigated to via the keyboard:
 * https://www.drupal.org/node/897638
 */

.visuallyhidden.focusable:active,
.visuallyhidden.focusable:focus {
    clip: auto;
    height: auto;
    margin: 0;
    overflow: visible;
    position: static;
    width: auto;
}

/*
 * Hide visually and from screen readers, but maintain layout
 */

.invisible {
    visibility: hidden;
}

/*
 * Clearfix: contain floats
 *
 * For modern browsers
 * 1. The space content is one way to avoid an Opera bug when the
 *    'contenteditable' attribute is included anywhere else in the document.
 *    Otherwise it causes space to appear at the top and bottom of elements
 *    that receive the 'clearfix' class.
 * 2. The use of 'table' rather than 'block' is only necessary if using
 *    ':before' to contain the top-margins of child elements.
 */

.clearfix:before,
.clearfix:after {
    content: " "; /* 1 */
    display: table; /* 2 */
}

.clearfix:after {
    clear: both;
}

/* ==========================================================================
   EXAMPLE Media Queries for Responsive Design.
   These examples override the primary ('mobile first') styles.
   Modify as content requires.
   ========================================================================== */

@media only screen and (min-width: 35em) {
    /* Style adjustments for viewports that meet the condition */
}

@media print,
       (min-resolution: 1.25dppx),
       (min-resolution: 120dpi) {
    /* Style adjustments for high resolution devices */
}

/* ==========================================================================
   Print styles.
   Inlined to avoid the additional HTTP request:
   http://www.phpied.com/delay-loading-your-print-css/
   ========================================================================== */

@media print {
    *,
    *:before,
    *:after,
    *:first-letter,
    *:first-line {
        background: transparent !important;
        color: #000 !important; /* Black prints faster:
                                   http://www.sanbeiji.com/archives/953 */
        box-shadow: none !important;
        text-shadow: none !important;
    }

    a,
    a:visited {
        text-decoration: underline;
    }

    a[href]:after {
        content: " (" attr(href) ")";
    }

    abbr[title]:after {
        content: " (" attr(title) ")";
    }

    /*
     * Don't show links that are fragment identifiers,
     * or use the 'javascript:' pseudo protocol
     */

    a[href^="#"]:after,
    a[href^="javascript:"]:after {
        content: "";
    }

    pre,
    blockquote {
        border: 1px solid #999;
        page-break-inside: avoid;
    }

    /*
     * Printing Tables:
     * http://css-discuss.incutio.com/wiki/Printing_Tables
     */

    thead {
        display: table-header-group;
    }

    tr,
    img {
        page-break-inside: avoid;
    }

    img {
        max-width: 100% !important;
    }

    p,
    h2,
    h3 {
        orphans: 3;
        widows: 3;
    }

    h2,
    h3 {
        page-break-after: avoid;
    }
}

#contentTable {
    margin: 0 auto 0 auto;
    width: 1260px;
    border-collapse: collapse;
}

#common-caption {
    position: relative;
    z-index: 2;
    margin: -194px 0 0 0;
    padding: 0 0 8px 432px;
}

#header-table {
    width: 100%;
    margin: 10px 0 10px 0;
}

#header-table td {
    /*width: 50%;*/
}

.feral-animal-div {
    width: 150px;
    height: 150px;
    display: block;
}

.sssnext, .sssprev {
    display: none;
}

#feral-animals-table2 {
    margin: 0 auto;
}

#feral-animals-table2 td {
    padding: 0 9px;
}

/* DEFAULTS
----------------------------------------------------------*/

@media print {
    .noprint {
        display: none !important;
    }

    .printreset {
        margin: 0 !important;
        padding: 0 !important;
    }

    .printtable td {
        padding: 0 !important;
        margin: 0 !important;
    }

    .printtable input {
        margin: 4px 0 !important;
        padding: 0.25rem 0.5rem 0.25rem 0.5rem !important;
    }
}

body {
    background: #ffffff;
    font-size: 1rem;
    font-family: 'Montserrat', sans-serif;
    line-height: 1.6rem;
    margin: 0;
    padding: 0;
    color: #000;
}

normal
{
    font-size: .80em;
    font-family: 'Montserrat', sans-serif;
    margin: 0;
    padding: 0;
    color: #000;
}

.divContent ul
{
	padding-left: 20px;
}

.normalImage
{
	display: inline;
}

a:link, a:visited, a:active, a:hover
{
	color: #AC3F30;
    color: var(--speciesSecondaryColor);
	text-decoration: none;
}

a:hover
{
	color: #ff6600;
    color: var(--speciesPrimaryColor);
}

p
{
    margin-bottom: 10px;
}

.contentHeader {
    padding-bottom: 8px;
}

/* LISTS   
----------------------------------------------------------*/

ol, ul {
    padding-inline-start: 30px;
}

/* HEADINGS   
----------------------------------------------------------*/
h1, h2, h3, h4, h5, h6 {
    text-transform: none;
    font-weight: 200;
    margin-bottom: 0;
    margin-top: 0;
}

h1
{
    font-size: 1.6rem;
    line-height: 2.4rem;
    padding-bottom: 0;
}

h2
{
    font-size: 1.5rem;
    line-height: 2.3rem;
    font-weight: 600;
    margin-bottom: 8px;
}

h3, h3 > a, h3 > a:link, h3 > a:visited {
    font-size: 1.4rem;
    font-weight: 500;
    color: #ff6600;
    color: var(--speciesPrimaryColor);
    line-height: 2.2rem;
}

h3 > a:hover {
    color: #AC3F30;
    color: var(--speciesSecondaryColor);
}

h4
{
    font-size: 1.2em;
}

h5, h6
{
    font-size: 1em;
}


/* this rule styles <h1> and <h2> tags that are the 
first child of the left and right table columns */
.rightColumn > h1, .rightColumn > h2, .leftColumn > h1, .leftColumn > h2
{
    margin-top: 0px;
}


/* PRIMARY LAYOUT ELEMENTS   
----------------------------------------------------------*/

.page
{
    width: 75%;
    background-color: #fff;
    margin: 20px auto 0px auto;
    border: 1px solid #496077;
}

.header
{
    position: relative;
    margin: 0px;
    padding: 0px;
    background: #4b6c9e;
    width: 100%;
}

.header h1
{
    font-weight: 700;
    margin: 0px;
    padding: 0px 0px 0px 20px;
    color: #f9f9f9;
    border: none;
    line-height: 2em;
    font-size: 2em;
}

.main
{
    padding: 0px 12px;
    margin: 12px 8px 8px 8px;
    min-height: 420px;
}

.leftCol
{
    padding: 6px 0px;
    margin: 12px 8px 8px 8px;
    width: 200px;
    min-height: 200px;
}

.footer
{
    color: #4e5766;
    padding: 8px 0px 0px 0px;
    margin: 0px auto;
    text-align: center;
    line-height: normal;
}

table.sponsorFooter td {
    vertical-align: middle;
    font-size: 9px; 
    font-weight: bold; 
    color: #444444;
    text-align: left;
}

/* MENU   
----------------------------------------------------------*/

td.menu
{
   text-align: left;
}


/* FORM ELEMENTS   
----------------------------------------------------------*/

fieldset
{
    margin: 1em 0px;
    padding: 1em;
    border: 1px solid #ccc;
}

fieldset p 
{
    margin: 2px 12px 10px 10px;
}

fieldset.login label, fieldset.register label, fieldset.changePassword label
{
    display: block;
}

fieldset label.inline 
{
    display: inline;
}

legend 
{
    font-size: 1.1em;
    font-weight: 600;
    padding: 2px 4px 8px 4px;
}

input.textEntry 
{
    width: 320px;
    border: 1px solid #ccc;
}

input.passwordEntry 
{
    width: 320px;
    border: 1px solid #ccc;
}

div.accountInfo
{
    width: 42%;
}

/* MISC  
----------------------------------------------------------*/

.clear
{
    clear: both;
}

.title
{
    display: block;
    float: left;
    text-align: left;
    width: auto;
}

.loginDisplay
{
    font-size: 1.1em;
    display: block;
    text-align: right;
    padding: 10px;
    color: White;
}

.loginDisplay a:link
{
    color: white;
}

.loginDisplay a:visited
{
    color: white;
}

.loginDisplay a:hover
{
    color: white;
}

.failureNotification
{
    font-size: 1.2em;
    color: Red;
}

.bold
{
    font-weight: bold;
}

.submitButton
{
    text-align: right;
    padding-right: 10px;
}

#tblAdminControlPanel {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    margin: 0 auto;
    width: 100%;
}

.admin-card {
    width: 100%;
    display: flex;
    justify-content: center;
}

.admin-card > .card {
    min-height: 160px;
    min-width: 280px;
    display: flex;
    flex-direction: row;
    align-items: center;
}

.admin-card img {
    padding-right: 12px;
}

@media only screen and (min-width: 900px) {
    .admin-card {
        width: 50%;
    }
}

@media only screen and (min-width: 1300px) {
    #tblAdminControlPanel {
        width: 75%;
    }
}

.adminPageContainer {
    position: relative;
    width: 280px;
    height: 150px
}

.adminPageInner
{
	border:solid 2px #7696CE;
	position:absolute;
	top:10px;
    bottom:10px;
	left:10px;
    right:10px;
	padding:15px 15px 15px 15px
}

.adminPageImage
{
	background-repeat:no-repeat;
	position:absolute;
	top:8px;
	left:18px;
	width:48px;
	height:48px
}

.adminPageText
{
	position:absolute;
	text-align:left;
	top:7px;
	left:90px;
}

.adminNavMenu {
    padding-left: 0px !important;
}
.adminNavMenu:after {
    content: '';
    display: block;
    clear: both;
}
.adminNavMenu li {
    float: left;
    list-style: none;
    text-align: center;
    margin-right: 30px;
    line-height: 30px;
    clear: right;
}

.adminNavMenu li a{
    color: #FFFFFF;
    font-weight: bold;
    border:1px solid #FFFFFF; 
     padding: 5px 5px 5px 5px; 
     text-decoration:none; 
     display:inline-block; 
 background-color: #575757; 

 
    border-radius: 7px;
    -moz-border-radius:7px;
    -webkit-border-radius: 7px;

}
 
.adminNavMenu li a:hover {
    text-decoration: none; 
    border:1px solid #FFFFFF;
 background-color: #bababa;
}

.defaultPageStoryTitle
{
	font-size: 11px;
	margin: 0px;
	font-weight: bold;
	color: #5F2B10;
}

.defaultPageStoryTitle:link
{
	color: #5F2B10;
}

.defaultPageStoryTitle:visited
{
	color: #5F2B10;
}

.defaultPageStoryTitle:hover
{
	color: #202020;
}

.defaultPageStoryText
{
	font-size: 10px;
	margin: 0px;
	line-height: 12px;
}

.collapseExandableImage {
    width: 16px;
    float: right;
    margin-right: 10px;
}

/* LOGIN DIV DISPLAY STYLES */

.pnlShow
{
	width:350px;
	height:330px;
	background-color:#FFFFFF;
	border:2px solid #000000;   
	position:absolute;
	display:none;
	padding: 12px;
	background-image:url('../images/contentTopFade.png');
	background-position: top;
	background-repeat: repeat-x;
}

#page_screen
{
    background-color:#000000;
    filter:alpha(opacity=00);  
    opacity: 0.0;     
    position:absolute;
    top:0px;
    left:0px;
    width:100%;
    display:none;
    z-index: 4;
}

.navButton
{
	border:solid 1px Navy;	
	background-color:#FFFFEE;
	border-style:ridge;
	height:30px;
}

.adminHomeLink
{
	padding-left: 5px;
	font-size: 16px;
}

.validatorAsterisk
{
	color: red;
}

.searchBox
{
	color: black;
	font-weight: bold;
	text-align: right;
	position: absolute;
	left: 149px;
	top: 4px;
	border: 1px solid #777777;
	font-size: 12px;
	width: 178px;
	padding: 0px;
	margin: 0px;
}

.youAreHereCombo
{
	font-weight: bold;
	border: 1px solid #777777;
	font-size: 12px;
	width: 111px;
	padding: 0px;
	margin: 0px;
	color: Black;
}

.youAreHereDiv
{
	position: absolute;
	left: 239px;
	top: 35px;
}

.pollBoxResults
{
    border-bottom:1px solid White;
    padding: 3px;
    padding-left: 5px;
    padding-right: 5px;
}

.pollBox span
{
    font-weight: bold;
    font-size: 13px;
}

.gallery img
{
	border: 0px none white;
}

.galleryCell
{
	font-size: 15px;
	font-weight: bold;
	vertical-align: middle;
	font-size: 12px;
    text-align: center;
}

.galleryCell img
{
	border: 3px solid #C8A582;
}

.galleryCell img:hover
{
	border: 3px solid #9E5730;
}

.footerCell a:link, .footerCell a:visited, .footerCell a:active
{
    color: #DDDDDD;
	font-size: 11px;
	font-weight: bold;
}

.footerCell a:hover
{
    color: #DDDDDD;
	font-size: 11px;
	font-weight: bold;
	text-decoration: underline;
}

td.mappingResultsCell 
{
    font-size: 13px;
    margin: 0;
    padding-bottom: 9px;
    padding-top: 205px;
}

td.mappingResultsTotalCell
{
    font-size: 11px;
    padding-right: 2px;
}

.mappingResultsCard 
{
    display: block;
    min-width: 200px;
    width: 80%;
}

@media only screen and (min-width: 700px) {
    .mappingResultsCard {
        width: 60%;
    }
}

@media only screen and (min-width: 700px) {
    .mappingResultsCard {
        width: 45%;
    }
}

@media only screen and (min-width: 992px) {

    .mappingResultsCard {
        width: 35%;
    }
}

@media only screen and (min-width: 1300px) {

    .mappingResultsCard {
        width: 75%;
    }
}

.mappingResultsLine {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    line-height: 40px;
}

.mappingResultsTotal
{
    padding: 10px;
    color: #38261b;
    font-weight: bold;
}

.mappingResultsPastYearTotalLabel
{
    font-size: 1.25rem;
    line-height: 1.6em;
}

.mappingResultsTotalLabel
{
    font-size: 1.25rem;
}

.mappingResultsPastYearValue 
{
    text-align: right;
    font-size: 1.5rem;
}

.mappingManagementTitle {
    text-align: center;
    font-size: 1.5rem;
    font-weight: bold;
}

.mappingResultsTotalValue
{
    text-align: right;
    font-size: 2.25rem;
}

.contentSwipeImage 
{
    padding-bottom: 12px;
    padding-top: 0px;
    margin: 0px;
}

.dashboard-controls {
    padding-left: 15px;
    padding-bottoM: 15px;
}


.dashboard-links {
    padding-left: 15px;
}

.resultCell,
.regionLinkCell {
    line-height: 13px;
}

.resultCell
{
	font-size: 11px;
	font-weight: bold;
	padding-left: 6px;
	padding-top: 1px;
	padding-bottom: 1px;
	text-align: left;
}

.mapContainer
{
	border-width: 3px;
	border-style: solid;
}

.newFeaturesBoxTitle
{
    font-size: 16px; 
    margin: 0px; 
    padding-bottom: 6px; 
    font-weight: bold; 
    color: #FFFFFF;
}

.newFeaturesBox,
.adviceBox
{
    padding: 9px 12px 12px; 
    margin-top: 12px;
}

.adviceBoxTitle
{
    font-size: 16px; 
    margin: 0px; 
    padding-bottom: 6px; 
    font-weight: bold; 
    color: #FFFFFF;
}
.newFeaturesBox ul,
.adviceBox ul
{
    margin: 0;
    padding: 0;
}

.newFeaturesBox ul li,
.adviceBox ul li
{
    list-style-type: none;
    background-repeat: no-repeat;
    background-position: 0 7px;
    padding: 3px 0 3px 12px;
    vertical-align: middle;
}

/* CONTROLS */
.controlNote
{
    margin-top: 10px;
    padding-left: 10px; 
    padding-right: 10px;
    font-weight: bold;
}

/* COMMUNITY GROUP */
.communityGroup {
}

.communityGroup img {
    border: 0;
    display: inline;
}

.communityGroup .communityGroupAdminEmailTemplate {
    background-color: #DDD;
    padding: 10px;
    margin: 10px;
}

/* HOMEPAGE */
.homePageMainContent img
{
    border: 0;
}

.tblHomePage
{
    width: 100% !important;
    line-height:22px;
}

.tblHomePage h2
{
    margin-top: 0px;
    padding-top: 0px;
}

.tblHomePage .blurb
{
    padding-left: 12px;
}

.tblHomePage td.blurbImage,
.tblHomePage td.blurb
{
    border-bottom: 1px solid silver;
    padding-bottom: 10px;
    padding-top: 10px;
}

.tblHomePage td.blurbImage,
.tblHomePage td.firstBlurbImage
{
    width: 150px;
}

.tblHomePage td.firstBlurbImage,
.tblHomePage td.firstBlurb
{
    border-top: 0px none;
}

.tblHomePage td.lastBlurbImage,
.tblHomePage td.lastBlurb
{
    padding-bottom: 0px;
    padding-top: 10px;
} 

.tblHomePage p
{
    margin-top: 6px;
}

td.mappingResultsCell 
{
    padding-top: 0;
}

.validationList
{
	color: Red;
}

.validationList ul
{
	padding-left: 16px;
}

.importantNote,
.error,
.validationError
{
    color: red !important;
}


.strongNote
{
    color: Maroon; 
    padding-left: 10px; 
    padding-right: 10px; 
    font-weight: bold;
}

.strongNoteDarkGrey
{
    color: #303030;
}

.text-align-left {
    text-align: left;
}

.text-align-center {
  text-align: center;
}

.text-align-right {
  text-align: right;
}

.hidden {
    display: none;
}

.fsTabControlButtons {
    padding: 30px 0 30px 0;
    text-align: center;
}

.fsTabStepText {
    padding-bottom: 30px;
    text-align: center;
}

.communityGroup .fsTabControlButtons {
    text-align: left;
}

.communityGroup .fsButton {
    margin: 5px 10px 20px 0;
}

.communityGroup .communityGroupSightingTotalsGrid,
.communityGroup .communityGroupMembersGrid,
.communityGroup .communityGroupMemberTotalsGrid {
	width:100%;
    margin-bottom: 10px;
}

.adminPage .communityGroup .communityGroupSightingTotalsGrid
{
	width:35%;
	float:left;
	margin-right:2%;
}

.adminPage .communityGroup .communityGroupMembersGrid
{
	width:63%;
	float:right;
}

.adminPageMenu 
{
    font-size: 1rem;
}

.adminPageMenu ul {
    display: flex;
    flex-direction: row;
    list-style: none;
    padding: 0;
    margin: 0;
    width: 100%;
}

.adminPageMenu li a {
    background-color: #f1f1f1;
    color: black;
    display: block;
    padding: 8px 16px;
    text-decoration: none;
}

.adminPageMenu li a:hover {
    background-color: #555;
    color: white;
}

.adminPageMenu li a > img {
    margin-right: 8px;
}

/*
Sighting species icons
*/

img.sightingIconSymbol {
    margin: 0;
    display: inline;
    vertical-align: middle;
    position: relative;
    top: -4px;
}

img.sightingIcon {
    margin: 4px 0;
    display: inline;
    vertical-align: middle;
}

img.sightingIconThumbnail {
    width: 30px;
}

.sideBox {
    margin-top: 12px;
}

.facebookSideBox {    
    background-color: #FFF;
}

/*
Gallery Photo Preview
*/
.galleryPhotoPreview {
    display: block;
    margin-top: 10px;
}

/*
Sighting Forms
*/
#tblSighting, 
#tblDamage, 
#tblControl,
#tblDisease {
	width: 100%;
}

#tblSighting > tbody > tr > td {
    padding: 0.25rem 0 0.25rem 0;
}

#tblDamage > tbody > tr > td {
    padding: 0.25rem 0 0.25rem 0;
}

#tblControl > tbody > tr > td {
    padding: 0.25rem 0 0.25rem 0;
}

#tblDisease > tbody > tr > td {
    padding: 0.25rem 0 0.25rem 0;
}

.communityGroupSightingTotalsGrid {
    overflow-x: auto;
}

.cgAdminPageContainer
{
	position:relative;
	width:280px;
	height:90px
}

.cgAdminPageInner
{
	border:solid 2px #7696CE;
	position:absolute;
	top:10px;
    bottom:10px;
	left:10px;
    right:10px;
}


.cgAdminPage td {
	border:solid 2px #7696CE;
	width:280px;
	height:90px;
    vertical-align: middle;
    padding-left: 10px;
    padding-right: 10px;
}


.cgAdminPageImage
{
	background-repeat:no-repeat;
	float:left;
	width:48px;
	height:48px
}

.cgAdminPageText
{
    padding: 10px;
    float:left;
	text-align:left;
    width: 70%;
	font-size: 1.1em;
}

.paddingLeft-15 {
    padding-left: 15px;
}

.paddingTop-15 {
    padding-top: 15px;
}

.no-image
{
    width: 70%;
    border: 1px solid;
    padding: 10px;
    box-shadow: 5px 5px 5px 5px #888888;
}

.disable-export-link {
    display: none;
}

.export-link {
    font-size: 1rem;
}

.export-link-text, .export-link-icon {
    vertical-align: middle;
    display: inline-block;
}

.export-link-icon {
    height: 1rem;
    width: 24px;
}

.records-title {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
}

/*
 * Feedback
 */

.feedback-container {

}

.feedback-question {
    display: flex;
    flex-direction: column;
    margin-bottom: 8px;
    background: rgba(230,230,230,0.3);
    border-radius: 4px;
    padding: 4px 8px;
}

.feedback-question-col {
    flex: 1;
    display: flex;
    flex-direction: column;
}

.feedback-question-input {
    margin-left: 4px;
    margin-bottom: 4px;
}

.feedback-question-submit input {
    width: 100%;
}

@media only screen and (min-width: 1300px) {
    .feedback-question {
        flex-direction: row;
        padding: 8px 16px;
        margin-bottom: 16px;
    }

    .feedback-question-col {
        flex-direction: row;
        align-items: center;
    }

    .feedback-question-input {
        margin: 0;
        flex: 1;
        text-align: center;
    }

    .feedback-question-input label {
        white-space: nowrap;
    }

    .feedback-question-input input {
        width: 100%;
        text-align: center;
    }

}


body {
    background: #583D15;
    background: var(--speciesBackground);
}

.pageContainerFixed {
    width: 100%;
    height: 93vh; /* fallback */
/*    height: calc(var(--vh, 1vh) * 100);*/
    overflow-x: hidden;
    overflow-y: scroll;
}

.pageContainerFixed, .pageContent {
    margin-top: 7vh; /* Fallback */
    margin-top: var(--pageHeaderHeight);
}

.pageContainerFixedHome {
    height: 100%;
    overflow: hidden;
    margin-left: auto;
    margin-right: auto;
    box-shadow: 0 0 10px 0 black;
}

.pageContainer > #MyDataSiteEventFilterBox {
    /* The control isn't embedded in the map as it's directly below page container ''*/
    top: 75px;
}

.pageContainer {
    height: 100%;
    overflow: hidden;
}

.pageHeaderContainer {
    position: fixed;
    z-index: 2;
    width: 100%;
}

.pageHeader {
    z-index: 1;
    width: 100vw;
    height: 7vh; /* Fallback */
    height: var(--pageHeaderHeight);
    display: flex;
    flex-direction: row;
    align-items: center;
}

.pageHeaderBackground {
    height: 7vh; /* Fallback */
    height: var(--pageHeaderHeight);
    width: 100%;
    background: rgb(254,254,254);
    box-shadow: 0 5px 10px rgba(0, 0, 0, 0.24);
    z-index: 1;
    position: fixed;
}

.pageHeaderLogo {
    margin-left: 6px;
    height: 60%;
    display: block;
    flex: 1;
    z-index: 1;
}

    .pageHeaderLogo img {
        height: 100%;
        display: inline;
    }

        .pageHeaderLogo img:hover {
            filter: brightness(0.7);
        }

.pageHeaderMenu {
    flex: 1;
    display: flex;
    justify-content: flex-end;
    flex-direction: row;
    font-size: 1rem;
    line-height: 1.5rem;
    z-index: 2;
}

    .pageHeaderMenu .pageHeaderMenu-item {
        margin: 0 6px
    }

.pageHeaderMenu-item.btnBase, .pageHeaderMenu-item > .btnBase {
    background: #ff6600;
    background: var(--speciesPrimaryColor);
    border: none;
}

.btnBase.mapFilterSearch {
    background-color: var(--speciesPrimaryColor);
    color: white;
}

.pageHeaderMenu-item img, .pageHeaderMenu-item svg {
    color: black;
    filter: invert(1);
}

.pageContent {
    height: 93vh; /*Fallback */
    /*     height: calc(var(--vh, 1vh) * 100);*/
    height: calc(100vh - var(--pageHeaderHeight));
    display: flex;
    position: relative;
}

.pageContentMap {
    height: 100%;
    width: 100%;
    display: flex;
    flex-direction:column;
}

.page-datamanagement {
    margin-top: 48px;
}

.page-dataaccess {
    display: flex;
    justify-content: center;
}

#mpcMapCanvas {
    flex: 1 1 auto;
}

#siteEventFormContainer {
    height: 100%;
    width: 100%;
    overflow: auto;
    position: absolute;
    z-index: 1;
    background: white;
    left: -105%;
    border: 1px solid rgba(150, 150, 150, 0.2);
}

#siteEventFormContainer.active {
    display: block;
    left: 0;
}

#siteEventHistoryContainer {
    height: 100%;
    width: 100%;
    overflow: auto;
    position: absolute;
    z-index: 1;
    background: white;
    left: -105%;
    border: 1px solid rgba(150, 150, 150, 0.2);
}

#siteEventHistoryContainer.active {
    display: block;
    left: 0;
}

.siteEventForm {
    padding: 1.25rem 0.5rem 0.25rem 0.5rem;
}

.siteEventFormHeader {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    padding-bottom: 8px;
}

.siteEventFormHeading {
    font-size: 1.5rem;
}

.siteEventFormTypeQuestion {
    font-size: 1em;
    white-space: nowrap;
}

.siteEventFormTypeQuestion .fs-form-item-input-radio {
    margin-left: 30px;
}

.siteEventSubForm {
    display: none;
}

    .siteEventSubForm.active {
        display: block;
    }

.pageButtons {
    height: 10vh; /* Fallback */
    height: calc(var(--vh, 1vh) * 15);
    display: flex;
    align-items: center;
    background: rgb(240, 241, 242);
    font-size: 0.85rem;
}

    .pageButtons > .pageBtn {
        flex: 1;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        height: 100%;
    }

.pageBtn:hover {
    color: #1890ff;
}

.pageBtn.active {
    color: #1890ff;
    background: rgb(255, 255, 255);
}

.pageBtnIcon {
    width: 24px;
    height: 24px;
    padding-right: 5px;
}

.pageBtnText {
    display: flex;
    align-items: center;
}

/* footer styling */

.new-default-footer-parent-links {
    width: 100%;
    padding: 0;
    margin: 0 auto;
}

.new-default-footer-child-links {
    position: relative;
    list-style-type: none;
    font-size: 0.8rem;
    text-align: center;
}

.new-default-footer-child-links ul {
    display: inline-block;
    text-align: left;
    padding-bottom: 10px;
}

.new-default-footer-parent-links .new-default-footer-social-icon-list {
    display: flex;
    justify-content: center;
}

.new-default-footer-child-left {
    color: dimgray;
    font-weight: 500;
}

.new-default-footer-social-icon {
    filter: brightness(30%);
    max-width: 100%;
    display: inline;
    height: 100%;
    max-height: 20px;
}

.new-default-footer-social-icon-list > li {
    margin-left: 8px;
}

.new-default-footer-social-icon-wrapper {
    display: flex;
    justify-content: center;
}

.new-default-footer-social-icon-wrapper > a {
    display: flex;
    justify-content: center;
    padding: 3px 2px;
}

.new-default-footer-social-contact {
    font-size: 0.75rem;
    font-weight: 500;
    color: #999;
}

.new-default-footer-social-contact > a{
    padding-right: 15px;
    font-weight: 600;
}

.new-default-footer-social-contact > a:link {
    color: #999;
}

.new-default-footer-social-contact > a:visited {
    color: #999;
}

.new-default-footer-social-contact > a:hover {
    cursor: pointer;
    color: #FF6600;
}

.new-default-visible-when-squeeze {
    visibility: visible;
}

/* footer styling - end */

@media only screen and (min-width: 360px) {
    .pageHeaderLogo {
        height: 80%;
    }
}

@media only screen and (min-width: 400px) {
    .pageButtons {
        font-size: 1.1rem;
    }

    .pageBtnIcon {
        width: 32px;
        height: 32px;
    }
}

@media only screen and (min-width: 1300px) {
    .pageHeader {
        width: 1260px;
        margin-left: auto;
        margin-right: auto;
    }

    .page-footer {
        width: 1260px;
        margin-left: auto;
        margin-right: auto;
    }

    .pageHeaderMenu-item-nav {
        display: none;
    }

    .pageContainerFixed {
        width: 1260px;
        height: auto;
        margin-left: auto;
        margin-right: auto;
        overflow: auto;
    }

    .pageContainerFixedHome {
        width: 1260px;
    }

    .pageContent {
        height: 93vh; /* Fallback */
        height: calc(var(--vh, 1vh) * 100);
        display: flex;
    }

    .pageContentMap {
        display: block;
    }

    #siteEventFormContainer {
        width: 400px;
        box-shadow: 0 3px 6px rgba(0, 0, 0, 0.24);
        transition-property: left;
        transition-duration: 0.3s;
        transition-timing-function: cubic-bezier(0.4, 0, 1, 1);
        transition-delay: 0s;
    }

    #siteEventHistoryContainer {
        width: 400px;
        box-shadow: 0 3px 6px rgba(0, 0, 0, 0.24);
        transition-property: left;
        transition-duration: 0.3s;
        transition-timing-function: cubic-bezier(0.4, 0, 1, 1);
        transition-delay: 0s;
    }

    .pageButtons {
        display: none;
    }

    .page-datamanagement {
        margin-top: 24px;
    }
}

/*
 * Footer
 */
.page-footer-container {
}

.page-footer {
    color: white;
    font-size: 0.9rem;
    line-height: 1.5rem;
    padding: 8px 24px;
}

    .page-footer a {
        color: #ffffff;
        text-decoration: underline;
    }

        .page-footer a:hover {
            color: #969696;
        }

        .page-footer a:active {
            color: #969696;
        }

.footer-text {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
}

    .footer-text > span {
        padding: 8px 0;
    }

.supporters-title {
    width: 100%;
    font-weight: bold;
    font-size: 0.9em;
    text-align: center;
    margin: 0;
    padding: 0;
    padding-top: 5px;
}

.supporters-container {
    background: #ffffff;
    margin: 0;
    list-style-type: none;
    display: flex;
    align-items: center;
    flex-direction: column;
    text-align: center;
}

.supporters-section {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;
    width: 100%;
}

.supporters-item {
    height: 60%;
    padding: 12px 24px;
    min-width: 150px;
    width: auto;
}

.supporters-item img {
    max-width: 100%;
    display: inline;
    height: 100%;
    max-height: 60px;
}

.supporters-item > a:hover {
    filter: opacity(0.7);
}

.social-icons {
    margin: 0 0;
    padding: 0;
    list-style-type: none;
}

.social-icons > li {
    display: inline-block;
    /*margin-right: 10px;*/
}

.social-icons > li:last-of-type {
    /*margin-right: 0;*/
}

@media only screen and (min-width: 600px) {
    .supporters-item {
        min-width: 150px;
        width: auto;
    }
}

@media only screen and (min-width: 800px) {
    
    /* footer styling */

    .new-default-footer-parent-links {
        width: 100%;
        justify-content: space-evenly;
        display: flex;
        padding: 0;
        margin: 0;
    }

    .new-default-footer-child-links {
        position: relative;
        width: 45%;
        list-style-type: none;
        font-size: 0.8rem;
        color: #333;
        text-align: left;
    }

    .new-default-footer-child-links > span {
        padding-left: 120px;
        -webkit-box-decoration-break: clone;
        box-decoration-break: clone;
    }

    .new-default-footer-parent-links .new-default-footer-social-icon-list {
        padding: 0;
        padding-left: 120px;
        justify-content: flex-start;
    }

    .new-default-visible-when-squeeze {
        visibility: hidden;
    }

    .new-default-footer-child-links ul {
        padding-bottom: 0;
    }

    /* footer styling - end */
}

@media only screen and (min-width: 1300px) {
    .page-footer {
        padding: 8px 0;
    }

    .footer-copyright {
        padding: 0;
    }

    .footer-text {
        flex-direction: row;
        align-items: center;
    }

    .footer-links {
        text-align: right;
        padding-bottom: 5px;
    }

    .supporters-item-left {
        margin-right: auto;
    }

    .supporters-container {
        flex-direction: row;
        justify-content: center;
        align-items: center;
    }

    .supporters-section {
        align-items: center;
    }

    .social-icons {
        text-align: right;
    }
}
`);

export interface ISpeciesContentStylesProps extends PropsWithChildren {
    headerHeight: number;
    primaryColor: string;
    secondaryColor: string;
    contrastColor: string;
    background: string;
}

const SpeciesContentStyles: FC<ISpeciesContentStylesProps> = ({
    background,
    contrastColor,
    headerHeight,
    primaryColor,
    secondaryColor,
    children
}) => {
    
    return (
        <Box
            sx={{
                '--pageHeaderHeight': `${headerHeight}px`,
                '--speciesPrimaryColor': primaryColor,
                '--speciesSecondaryColor': secondaryColor,
                '--speciesContrastColor': contrastColor,
                '--speciesBackground': `url('${background}')`
            }}
        >
            <ContentStyles>
                {children}
            </ContentStyles>
        </Box>
    );
}

export default SpeciesContentStyles;